import React, { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import RadioGroup from '../../elements/form/RadioGroup'
import { discountTypes } from '../scholarships/NewScholarship'
import NumberField from '../../elements/form/NumberField'
import TextareaField from '../../elements/form/TextareaField'
import OTPInput from '../../elements/form/OtpInput'
import { useDispatch } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'

const AddInvoiceDiscount = ({assignment, closeFunction}) => {
    const [processing, setProcessing] = useState(false)
    const [requirePasscode, setRequirePasscode] = useState(false)
    const [discountPayload, setDiscountPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})

    const dispatch = useDispatch()

    const validateForm = () => {
        let errors = {}

        if(!discountPayload.type || discountPayload.type === ''){
            errors.type = true
        }

        if(!discountPayload.amount || discountPayload.amount === '' || discountPayload.amount < 1){
            errors.amount = true
        }

        if(!discountPayload.description || discountPayload.description === ''){
            errors.description = true
        }

        setValidationErrors(errors)
        return errors
    }

    const pushUpdate = async () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        try {
            const headers = authHeader()
            setProcessing(true)
            await axios.post(`${baseUrl}/invoice-assignments/${assignment._id}/add-discount`, discountPayload, {headers})
            setProcessing(false)
            dispatch({
                type: SET_SUCCESS,
                payload: 'discount process initiated successfully, please provide OTP to confirm.'
            })
            setRequirePasscode(true)
            // closeFunction()
            
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    const [passcode, setPasscode] = useState('')

    const confirmUpdate = async() => {
        if(passcode === '' || passcode.length < 6) {
            return
        }
        try {
            const headers = authHeader()
            setProcessing(true)
            await axios.post(`${baseUrl}/invoice-assignments/${assignment._id}/add-discount/confirm`, {confirmationCode: passcode}, {headers})
            setProcessing(false)
            dispatch({
                type: SET_SUCCESS,
                payload: 'discount applied successfully!'
            })
            // se(true)
            closeFunction()
            
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    return (
        <div className='w-full'>
            <p className='text-sm text-gray-600 mb-[20px]'>Add a discount for the invoice <span className='font-[550] text-gray-800'>{assignment.invoice.name} ({assignment.invoice.invoiceCode})</span> assigned to <span className='font-[550] text-gray-800'>{assignment.student.fullName}</span></p>
            <div className='my-2'>
                <RadioGroup 
                    items={discountTypes} 
                    inline={false}
                    preSelectedIndex={discountTypes.findIndex(item => item.value === discountPayload.type)}
                    inputLabel={'Discount Type'}
                    requiredField={true}
                    returnSelected={(value) => {setDiscountPayload({...discountPayload, ...{type: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            <div className='w-full my-2'>
                <NumberField
                    inputType="number" 
                    fieldId={`discount-amount`}
                    inputPlaceholder={`Provide amount discounted ${discountPayload.discountType === 'PERCENTAGE' ? '(percentage amount)' : '(flat amount)'}`}
                    inputLabel={`Discount`} 
                    requiredField={true}
                    preloadValue={discountPayload.amount || ''}
                    hasError={validationErrors.amount} 
                    returnFieldValue={(value)=>{setDiscountPayload({...discountPayload, amount: value})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Descripton/Reason for discount" 
                    fieldId="description-note" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={discountPayload.descripton || ''}
                    inputPlaceholder={`Write a short description or justifucation for this discount`}
                    hasError={validationErrors.description} 
                    returnFieldValue={(value)=>{setDiscountPayload({...discountPayload, ...{description: value}})}}
                />
            </div>

            {requirePasscode && <div className='w-[80%] mx-auto mt-[20px]'>
                <p className='text-sm text-green-600 mb-[10px]'>Please check your email. We sent a 6-digit OTP to approve this discount.</p>
                <OTPInput length={6} onChange={(value) => {setPasscode(value)}} />
            </div>}


            <div className="mt-8 flex flex-row-reverse gap-x-4">
                {!requirePasscode? 
                    <ModalActionButton
                        buttonLabel={`Enable Discount`}
                        buttonAction={()=>{pushUpdate()}}
                        processing={processing}
                    />
                    
                    : 

                    <ModalActionButton
                        buttonLabel={`Confirm Discount`}
                        buttonAction={()=>{confirmUpdate()}}
                        processing={processing}
                    />
                }

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default AddInvoiceDiscount